module.exports = __webpack_public_path__ + "img/A28766_E4D6C3_D6C4AA_CAB598-256px.93031503.png";